import { useState, useEffect } from 'react';
import ReactHelmet from 'react-helmet';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

const CookieConsent = () => {
  const [consent, setConsent] = useState<boolean | null>(null);

  useEffect(() => {
    // Check if consent was previously given
    const savedConsent = localStorage.getItem('cookieConsent');
    if (savedConsent !== null) {
      setConsent(savedConsent === 'true');
    }
  }, []);

  const handleAccept = () => {
    setConsent(true);
    localStorage.setItem('cookieConsent', 'true');
    // Initialize Google Analytics with consent
    window.gtag('consent', 'update', {
      'analytics_storage': 'granted'
    });
  };

  const handleDecline = () => {
    setConsent(false);
    localStorage.setItem('cookieConsent', 'false');
    // Disable Google Analytics
    window.gtag('consent', 'update', {
      'analytics_storage': 'denied'
    });
  };

  if (consent !== null) {
    return null; // Don't show banner if consent was already given
  }

  return (
    <>
      <ReactHelmet>
        {/* Google Analytics Script */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-2WDRQRQSF2"></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-2WDRQRQSF2', {
              'consent_mode': {
                'analytics_storage': 'denied'
              }
            });
          `}
        </script>
      </ReactHelmet>
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        color: 'white',
        padding: '1rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        zIndex: 1000,
        gap: '1rem'
      }}>
        <div style={{ flex: 1 }}>
          <p style={{ margin: 0 }}>
            I use cookies to analyze site traffic and optimize your experience. 
            By clicking "Accept", you consent to my use of cookies for analytics purposes.
          </p>
        </div>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <button
            onClick={handleDecline}
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: 'transparent',
              border: '1px solid white',
              color: 'white',
              cursor: 'pointer',
              borderRadius: '4px'
            }}
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: 'white',
              border: 'none',
              color: 'black',
              cursor: 'pointer',
              borderRadius: '4px'
            }}
          >
            Accept
          </button>
        </div>
      </div>
    </>
  );
};

export default CookieConsent; 